const IF = require( "infrontjs" );

export class User extends IF.PathObject
{
    constructor( props = {} )
    {
        super( props );
    }

    setData( key, value )
    {
        const data = this.get( 'data' );
        if ( !data )
        {
            this.set( 'data', {} );
        }

        this.set( 'data.' + key, value );
    }

    getData( key, defRet = null )
    {
        return this.get( 'data.' + key, defRet );
    }
}
